<div class="terms-wrapper">
  <div class="container position-relative">
    <a (click)="goBack()" style="cursor: pointer;">
      <img src="assets/images/arrow_left_alt.svg" class="arrow" />
    </a>
    <h1 class="page-title ms-5">Privacy Policy</h1>
  </div>

  <p class="body-text">
    BeExpert ("we", "us", "our") respects your privacy and is committed to protecting your personal data. By using
    the BeExpert application and services, you consent to the collection and use of your information as described in
    this Privacy Policy.
  </p>

  <h2 class="section-title">1. Information We Collect</h2>
  <span>We may collect the following information when you register or use the BeExpert platform:</span>
  <ul class="body-text">
    <li>
      Name and email address for account identification and communication
    </li>
    <li>
      Phone number for secure OTP-based authentication, account verification,
      and prevention of duplicate or fraudulent accounts
    </li>
    <li>
      Location details including city and pincode to enable region-specific mentor
      assignment, expert availability, and accurate scheduling of mentorship sessions
    </li>
    <li>
      Session booking and scheduling details
    </li>
    <li>
      Platform usage logs and interaction data
    </li>
    <li>
      AI interview inputs including questions and responses provided by users
    </li>
    <li>
      Payment details processed securely through Razorpay
    </li>
    <li>
      Device information and IP address for security and fraud prevention
    </li>
  </ul>

  <span>We do not store credit or debit card details.</span>

  <h2 class="section-title">2. How We Use Your Information</h2>
  <span>We use the collected information strictly for providing and operating the core features of the BeExpert
    platform, including:</span>
  <ul class="body-text">
    <li>Secure user authentication and account verification using OTP</li>
    <li>Preventing misuse of free trials, AI interview attempts, and platform abuse</li>
    <li>Scheduling mentorship sessions and managing expert availability</li>
    <li>Assigning mentors and services based on regional availability</li>
    <li>Delivering mentor-led and AI-powered interview preparation services</li>
    <li>Providing personalized feedback, reports, and performance insights</li>
    <li>Processing payments securely</li>
    <li>Maintaining platform security, integrity, and reliability</li>
  </ul>


  <h2 class="section-title">3. Data Security</h2>
  <span>We implement industry-standard security measures to protect user data, including:</span>
  <ul class="body-text">
    <li>Data encryption in transit and at rest</li>
    <li>Secure server infrastructure</li>
    <li>Access logs and monitoring</li>
    <li>Role-based access controls to restrict data access to authorized personnel only</li>
  </ul>


  <h2 class="section-title">4. Sharing of Information</h2>
  <span>We share user data only where necessary for core platform functionality, including:</span>
  <ul class="body-text">
    <li>Razorpay for secure payment processing</li>
    <li>OpenAI for processing AI-powered interview and mentorship queries</li>
    <li>Authorized internal team members strictly for support, operations, and service delivery</li>
  </ul>

  <span>We do not sell, rent, or trade users’ personal information, including phone numbers, city, or pincode, to any
    third parties.</span>

  <h2 class="section-title">5. Cookies & Tracking</h2>
  <span>Cookies and similar technologies may be used for:</span>
  <ul class="body-text">
    <li>User authentication and session management</li>
    <li>Platform analytics and performance monitoring</li>
    <li>Improving overall user experience</li>
  </ul>
  <span>Users may disable cookies through their browser settings, though certain features may not function
    correctly.</span>

  <h2 class="section-title">6. User Rights</h2>
  <span>Users have the right to:</span>
  <ul class="body-text">
    <li>Request access to their personal data</li>
    <li>Request corrections to inaccurate information</li>
    <li>Request account and data deletion</li>
    <li>Opt out of non-essential communications</li>
  </ul>
  <span>Requests can be made by contacting us at the email address provided below.</span>

  <h2 class="section-title">7. Data Retention</h2>
  <span>We retain personal data only for as long as necessary to:</span>
  <ul class="body-text">
    <li>Deliver our services</li>
    <li>Meet legal and regulatory obligations</li>
    <li>Maintain platform security and prevent fraud</li>
  </ul>
  <span>Users may request deletion of their data at any time.</span>

  <h2 class="section-title">8. Legal Compliance</h2>
  <span>We comply with applicable data protection laws, including:</span>
  <ul class="body-text">
    <li>The Indian Digital Personal Data Protection Act (DPDPA)</li>
    <li>General Data Protection Regulation (GDPR), where applicable</li>
  </ul>

  <h2 class="section-title">9. Contact</h2>
  <span>For any questions or concerns regarding this Privacy Policy or your data, please contact us at:</span>
  <p>
    <i class="bi bi-envelope"></i> Email:
    <span class="email-value">{{ email }}</span>
  </p>
</div>